import { useContext } from 'react';
import {
  Stack,
  Typography,
} from '@mui/material';
import BottomNavigation from '../../../components/MenuBottomNavigation';
import { WebsiteContext } from '@/pages/website/WebsiteProvider';
import { useFetchMenusQuery } from '@/features/organizations/api/menusApi';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import MenuCard from '@/pages/menu/components/MenuCard';
import './MenuList.scss';
import MenuSkeleton from './MenuSkeleton';

const Home = () => {
  const { organization } = useContext(WebsiteContext);

  const menusQuery = useFetchMenusQuery(organization?.id ?? skipToken, {
    skip: !organization?.id
  });

  return (
    <div className="menu-list">
      <div className="body">
        {menusQuery.isLoading ? (
          <Stack spacing={2}>
            {[1,2,3].map((key) => <MenuSkeleton key={key} />)}
          </Stack>
        ) : Array.isArray(menusQuery.data) ? (
          <Stack spacing={2}>
            <Typography variant="h2">
              Menús disponibles
            </Typography>
            {menusQuery.data
              .filter((menu) => Boolean(menu.isPublished))
              .map((menu) => <MenuCard key={menu.id} {...menu} />
            )}
          </Stack>
        ) : (
          <Stack spacing={2} justifyContent={'center'} alignItems={'center'}>
            <Typography fontSize="4rem">🌵</Typography>
            <Typography variant="h2" color="black">
              Lo sentimos
            </Typography>
            <Typography variant="body1">
              Por el momento no tenemos menús disponibles
            </Typography>
          </Stack>
        )}
      </div>
      <div className="bottom">
        <BottomNavigation />
      </div>
    </div>
  );
};

export default Home;
